import { NoteSort as GqlNoteSort, Order as GqlNoteOrder } from '@smile-next/api/lib/note';
/**
 * 並べ替え項目クラス
 */
var SortCondition = /** @class */ (function () {
    function SortCondition(props) {
        this.sort = props.sort;
        this.order = props.order;
    }
    SortCondition.fromQuery = function (props) {
        return new SortCondition({
            sort: props.sort || defaultSortConditionObject.sort,
            order: props.order || defaultSortConditionObject.order,
        });
    };
    Object.defineProperty(SortCondition.prototype, "toString", {
        get: function () {
            return this.sort + " " + this.order;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toQueryArray", {
        get: function () {
            return { sortItem: this.sort, sortOrder: this.order };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toGqlNoteSort", {
        get: function () {
            switch (this.sort) {
                case 'TITLE':
                    return GqlNoteSort.Title;
                case 'CREATED_DATETIME':
                    return GqlNoteSort.CreatedDatetime;
                case 'UPDATED_DATETIME':
                    return GqlNoteSort.UpdatedDatetime;
                default:
                    throw new Error();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toGqlNoteOrder", {
        get: function () {
            switch (this.order) {
                case 'DESC':
                    return GqlNoteOrder.Desc;
                case 'ASC':
                    return GqlNoteOrder.Asc;
                default:
                    throw new Error();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toGqlSortCondition", {
        get: function () {
            return { noteSort: this.toGqlNoteSort, order: this.toGqlNoteOrder };
        },
        enumerable: false,
        configurable: true
    });
    return SortCondition;
}());
export { SortCondition };
export var defaultSortConditionObject = {
    sort: 'UPDATED_DATETIME',
    order: 'DESC',
};
